import React, { useEffect } from "react";
import { LanguageProvider } from "../../components/LanguageContext";
import ProjectsPage from "./ProjectsPage";
import { animateScroll as scroll } from "react-scroll";
import { OverflowContainer } from "../Home/HomeElements";

const Projects = () => {
  useEffect(() => {
    scroll.scrollToTop();
  }, []);

  return (
    <LanguageProvider>
      <OverflowContainer>
        <ProjectsPage></ProjectsPage>
      </OverflowContainer>
    </LanguageProvider>
  );
};

export default Projects;
